import { forwardRef, useMemo } from 'react'
import { CropperTransitions, CropperImage, CropperState } from 'react-advanced-cropper'
import { getBackgroundStyle } from 'advanced-cropper'
import { observer } from 'mobx-react-lite'

import { EditableImage } from './EditableImage'
import { EditContext } from './types'

type DesiredCropperRef = {
    getState: () => CropperState
    getTransitions: () => CropperTransitions
    getImage: () => CropperImage
}

type EditableImageBackgroundProps = {
    className?: string
    cropper: DesiredCropperRef
    context: EditContext
}

export const EditableImageBackground = observer(
    forwardRef<HTMLCanvasElement, EditableImageBackgroundProps>(
        ({ className, cropper, context }: EditableImageBackgroundProps, ref) => {
            const state = cropper.getState()
            const transitions = cropper.getTransitions()
            const image = cropper.getImage()

            const style = useMemo(
                () => (image && state ? getBackgroundStyle(image, state, transitions) : {}),
                [image, state, transitions]
            )

            return <EditableImage className={className} src={image?.src} context={context} ref={ref} style={style} />
        }
    )
)
